import {
  Box,
  Flex,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import trashIcon from "../../assets/images/projectManagement/trash-2.svg";
import imageIcon from "../../assets/images/projectManagement/image.svg";
// import { ChevronDownIcon } from "@chakra-ui/icons";
import iconFile from "../../assets/images/projectManagement/file-text.svg";
import SearchableSelect from "../selectForm";
import { StatusIsFileSelect } from "../../utils/contants";

export const FormFileBonus = ({
  id,
  deleteData,
  value,
  name,
  nameFileMain,
  onChangeFile,
  nameLinkFile,
  onChangeNameFile,
  file,
  onChangeLinkFile,
  onChangeTypeFile,
  status,
  path,
  typeFile,
  fileSelect,
  isRequired,
  isError,
  isErrorItem,
}) => { 
  const [nameFile, setNameFile] = useState(name || "");
  const [linkFile, setLinkFile] = useState(name || "");
  const [nameFileData, setNameFileData] = useState(nameFileMain || "");
  const [linkFileData, setLinkFileData] = useState(nameLinkFile || "");
  const [isFileSelect, setIsFileSelect] = useState(typeFile);
  // useEffect(() => {
  //   if (nameFile) setNameFile(nameFileMain);
  // }, [nameFileMain, nameFile]);

  useEffect(() => {
    if (typeFile && (status || nameFile !== nameFileData)) {
      const delayDebounce = setTimeout(() => {
        onChangeActionName?.(nameFileData, true);
      }, 500);

      return () => clearTimeout(delayDebounce);
    }
  }, [nameFileData, status]);

  useEffect(() => {
    if ((!typeFile && status) || path !== linkFileData) {
      const delayDebounce = setTimeout(() => {
        onChangeActionName?.(linkFileData, false);
      }, 500);

      return () => clearTimeout(delayDebounce);
    }
  }, [linkFileData, status]);

  useEffect(() => {
    if (isFileSelect === 2) onChangeTypeFile(true);
    else onChangeTypeFile(false);
  }, [isFileSelect]);

  const openFile = (event) => {
    const file = event.target.files[0];

    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

    if (!allowedTypes.includes(file.type) && typeFile === "image") {
      event.target.value = "";
      return;
    }

    if (file) {
      onChangeFile(file);
      setNameFile(file?.name);
      setNameFileData(file?.name);
      setLinkFile(file?.name);
      setLinkFileData(file?.name.trim());
    }
  };

  const onChangeActionName = (newValue, type) => {
    if (type === true) {
      setNameFileData(newValue);
      onChangeNameFile?.(newValue);
    } else {
      setLinkFileData(newValue);
      onChangeLinkFile?.(newValue);
    }
  };

  return (
    <Box borderBottom={"1px solid var(--color-black-2)"} paddingBottom={"16px"}>
      <Box>
        {fileSelect && (
          <Box w={"100%"} mb={"16px"}>
            <SearchableSelect
              isShowSearch={false}
              options={StatusIsFileSelect}
              initialSelectedOption={{
                key: isFileSelect,
                value: isFileSelect === 2 ? "Link" : "Upload file",
              }}
              setValue={setIsFileSelect}
            />
          </Box>
        )}
        <Flex
          justifyContent={"space-between"}
          alignItems={"center"}
          gap={"27px"}
          w={"100%"}
        >
          <Flex w={"100%"} alignItems={"center"} gap={"12px"}>
            <Box w={"100%"}>
              <Flex alignItems="center" gap="4px">
                <Text
                  fontSize={{ base: "12px" }}
                  fontWeight={400}
                  lineHeight={"15px"}
                  color={"var(--color-label-employee)"}
                  mb={"6px"}
                >
                  {typeFile === "image"
                    ? "Tên ảnh"
                    : fileSelect && isFileSelect && isFileSelect === 2
                    ? "Tên đường dẫn"
                    : "Tên file, ảnh"}
                </Text>
                {isRequired && (
                  <Text
                    fontSize={{ base: "12px" }}
                    color={"red"}
                    lineHeight={"15px"}
                  >
                    *
                  </Text>
                )}
              </Flex>
              <Input
                color="var(--text-color-Subtittle)"
                fontWeight={500}
                fontSize={"14px"}
                placeholder={
                  typeFile === "image"
                    ? "Vui lòng nhập tên ảnh"
                    : "Vui lòng nhập tên file, ảnh"
                }
                type={"text"}
                _focus={{
                  boxShadow: "none",
                }}
                h={"44px"}
                value={nameFileData || value || ""}
                onChange={(e) => {
                  const newValue = e.target.value;
                  setNameFileData(newValue);
                }}
              />
            </Box>
            {fileSelect && isFileSelect && isFileSelect === 2 ? (
              <Box w={"100%"}>
                <Flex alignItems="center" gap="4px">
                  <Text
                    fontSize={{ base: "12px" }}
                    fontWeight={400}
                    lineHeight={"15px"}
                    color={"var(--color-label-employee)"}
                    mb={"6px"}
                  >
                    Đường dẫn
                  </Text>
                  {isRequired && (
                    <Text
                      fontSize={{ base: "12px" }}
                      color={"red"}
                      lineHeight={"15px"}
                    >
                      *
                    </Text>
                  )}
                </Flex>
                <Input
                  color="var(--text-color-Subtittle)"
                  fontWeight={500}
                  fontSize={"14px"}
                  placeholder={"Vui lòng nhập tên đường dẫn"}
                  type={"text"}
                  _focus={{
                    boxShadow: "none",
                  }}
                  h={"44px"}
                  value={linkFileData || value || ""}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    setLinkFileData(newValue.trim());
                  }}
                />
              </Box>
            ) : (
              <Box w={"100%"}>
                <Flex alignItems="center" gap="4px">
                  <Text
                    fontSize={{ base: "12px" }}
                    fontWeight={400}
                    lineHeight={"15px"}
                    color={"var(--color-label-employee)"}
                    mb={"6px"}
                  >
                    {typeFile === "image" ? "Ảnh" : "File, ảnh"}
                  </Text>
                  {isRequired && (
                    <Text
                      fontSize={{ base: "12px" }}
                      color={"red"}
                      lineHeight={"15px"}
                    >
                      *
                    </Text>
                  )}
                </Flex>

                <InputGroup
                  mt={"0"}
                  p={{ base: "14px 12px 13px 12px" }}
                  alignItems={"center"}
                  h={"44px"}
                  border={"0.5px solid var(--Line)"}
                  borderRadius={"8px"}
                  _focus={{
                    boxShadow: "none",
                  }}
                  position={"relative"}
                >
                  <Input
                    type="file"
                    accept={
                      typeFile === "image"
                        ? ".png,.jpg,.jpeg"
                        : "image/*, .pdf, .doc, .docx"
                    }
                    //   multiple={true}
                    opacity={0}
                    position="absolute"
                    top={0}
                    left={0}
                    width="100%"
                    height="100%"
                    onChange={openFile}
                    w={"100%"}
                    h={"100%"}
                    zIndex={3}
                    p={0}
                    cursor={"pointer"}
                  />
                  <Input
                    color="var(--text-color-Subtittle)"
                    fontWeight={500}
                    fontSize={"14px"}
                    border={"none"}
                    p={"0px"}
                    placeholder={
                      typeFile === "image"
                        ? "Vui lòng chọn ảnh"
                        : "Vui lòng chọn file, ảnh"
                    }
                    type={"text"}
                    pr={"18px"}
                    _focus={{
                      boxShadow: "none",
                    }}
                    value={nameFile || value || ""}
                    onChange={() => {}}
                  />
                  <InputRightElement>
                    <Image
                      zIndex={"1"}
                      cursor={"pointer"}
                      src={typeFile === "image" ? imageIcon : iconFile}
                      //   onClick={handleClick}
                    />
                  </InputRightElement>
                </InputGroup>
              </Box>
            )}
          </Flex>
          <Image
            cursor={"pointer"}
            src={trashIcon}
            h={"22px"}
            w={"22px"}
            mr={"12px"}
            minH={"22px"}
            minW={"22px"}
            onClick={deleteData}
            _hover={{
              filter: "var(--filter-red)",
            }}
          />
        </Flex>
      </Box>
      {isError &&
        typeFile === 1 &&
        (!nameFileData || !file) && (
          <Text w="100%" color="var(--text-red-employee)" fontSize="12px">
            Vui lòng nhập đầy đủ tên ảnh và file, hoặc tên file và file
          </Text>
        )}
      {isError && typeFile === 2 && (!nameLinkFile || !nameFileMain) && (
        <Text w={"100%"} color={"var(--text-red-employee)"} fontSize={"12px"}>
          Vui lòng tên và đường dẫn
        </Text>
      )}

      {isErrorItem?.status && isErrorItem?.id === id && (
        <Text w={"100%"} color={"var(--text-red-employee)"} fontSize={"12px"}>
          Đường dẫn đã tồn tại, vui lòng nhập đường dẫn khác.
        </Text>
      )}
    </Box>
  );
};
